import React, { Component } from "react";
import Footer from "../../components/Footer/footer";
import NavbarPage from "../../components/Navbar/Navbar_Page";
import Section from "./section";

class Index1 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pos: document.documentElement.scrollTop,
      imglight: false,
      navClass: "",
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.scrollNavigation, true);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.scrollNavigation, true);
  }

  scrollNavigation = () => {
    let scrollup = document.documentElement.scrollTop;
    if (scrollup > this.state.pos) {
      this.setState({ navClass: "nav-sticky", imglight: false });
    } else {
      this.setState({ navClass: "", imglight: false });
    }
  };

  render() {
    return (
      <React.Fragment>
        {/* Importing Navbar */}
        <NavbarPage
          navItems={this.state.navItems}
          navClass={this.state.navClass}
          imglight={this.state.imglight}
        />

        {/* Importing section */}
        <Section
          title={"Door-to-Door Rent a bakkie Services in Polokwane"}
          titleTemplate={"QikTruck"}
          titleSeparator={"-"}
          image={"https://media.qiktruck.co.za/qiktruck-preview-header.png"}
          pathname={"https://qiktruck.co.za/rent-a-bakkie-polokwane"}
          pageHeading={"Door-to-Door Rent a bakkie Services in Polokwane"}
          pageSubHeading={"For your home or business"}
          pageDescription={"Get convenient door-to-door Rent a bakkie services in Polokwane with our team of experienced drivers and state-of-the-art vehicles at QikTruck. We offer a range of delivery options to meet your needs, including same-day and next-day delivery. Sign up now and start enjoying the convenience of our services."}
          pageDescription2={"Need convenient door-to-door Rent a bakkie services in Polokwane? Look no further! Our team of experienced drivers and state-of-the-art vehicles at QikTruck ensure that your packages will arrive safely and on time. We offer a range of delivery options to meet your needs, including same-day and next-day delivery. Sign up now and start enjoying the convenience of our services."}
        />

        {/* Importing Footer */}
        <Footer />
      </React.Fragment>
    );
  }
}

export default Index1;
